<div class="header">
  <h2>Administrador general → Destinatarios</h2>
  <app-navegacion></app-navegacion>
</div>
<div class="container">
  <div class="filter">
    <app-generic-select [options]="myOptions" placeholder="Filtro" (selectionChange)="onSelected($event)">
    </app-generic-select>
  </div>

  <app-boton-primario boton_texto="Nuevo" (boton_funcion)="newDestinatario()"></app-boton-primario>

  <table>
    <thead>
      <tr>
        <th scope="col">Tipo</th>
        <th scope="col">Destinatario</th>
        <th scope="col">Descripción</th>
        <th scope="col">Activo</th>
        <th scope="col">Horario</th>
        <th scope="col">Fecha de creación</th>
        <th scope="col">Creado por</th>
        <th scope="col">Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let destinatario of destinatarios; let i = index" (click)="editDestinatario(destinatario)">
        <td>{{ destinatario.tipo }}</td>
        <td>{{ destinatario.destinatario }}</td>
        <td>{{ destinatario.descripcion }}</td>
        <td>{{ destinatario.activo ? "Sí" : "No" }}</td>
        <td>{{ destinatario.horario }}</td>
        <td>{{ destinatario.fechaCreacion }}</td>
        <td>{{ destinatario.creadoPor }}</td>
        <td>
          <div class="buttons">
            <button (click)="editDestinatario(destinatario)">
              <img src="assets/images/admin-asistente-images/EditYellow.png" width="17.5px" height="17.5px" />
            </button>
            <button (click)="deleteDestinatario(i)">
              <img src="assets/images/admin-asistente-images/TrashRed.png" width="17.5px" height="17.5px" />
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>